// src/fetchs/PrecoRegraQuery.js
import { db } from "~/db/db";

export const PrecoRegraQuery = ({ clienteId, microrregiao, cluster, cidadeId, domicilioFiscal }) => {
  let precosQuery = db.tabelaPrecoCliente;
  const codigoIbge = domicilioFiscal?.replace?.(/\D/gim, "") ?? "";

  if (clienteId > 0 && microrregiao && cluster)
    precosQuery = precosQuery.filter(
      (e) =>
        e.microrregiaoId == microrregiao &&
        (e.clusterId == cluster ||
          (!e.clusterId && !e.cidadeId) ||
          (!e.clusterId ? !e.cidadeId || e.cidadeId == cidadeId || e.cidadeCodigoIbge == codigoIbge : false)) &&
        (e.clienteId == clienteId || !e.clienteId)
    );
  else if (clienteId > 0 && microrregiao)
    precosQuery = precosQuery.filter(
      (e) =>
        e.microrregiaoId == microrregiao &&
        (e.clienteId == clienteId || !e.clienteId)
    );
  else if (clienteId > 0)
    precosQuery = precosQuery.filter((e) => e.clienteId == clienteId || !e.clienteId);

  return precosQuery;
};
